import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
    ModalItem,
    Form,
    FormItem,
    InputItem,
    HeaderItem,
    BoxItem,
    SelectItem,
    ButtonItem,
    TextAreaItem,
    CheckItem,
    SwitchItem,
} from "../../../../Components/Items";
import { Row, Col, Spin, message, Select, Upload, Alert } from "antd";
import { PictureOutlined } from "@ant-design/icons";

const { Option } = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class ModalMarca extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        proveedores: [],
        proveedorId: null,
        empresaNombreCompleto: "",
    };

   componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
       this.consultarProveedores();
       this.consultarEmpresaActual();
        if (this.props.modo === "editar" && this.props.marcaId) {
            //Prellenar los datos según el marcaId
            this.consultarMarcaPorId(this.props.marcaId);
            this.formRef.current.setFieldsValue({ aceptaResponsabilidad: false });
        } else {
            this.formRef.current.resetFields();
        }
    }
  }

    //Función para consultar el nombre completo de la empresa actual
    consultarEmpresaActual = async () => {
        try {
            const res = await axios.post(
                "empresas/selectConfiguracionGeneral",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );
            if (res.data && res.data.status !== 404) {
                const nombreCompleto = res.data.persona
                    ? res.data.nombre
                    : `${res.data.nombre || ""} ${res.data.apellidoPaterno || ""} ${res.data.apellidoMaterno || ""}`.trim();
                this.setState({ empresaNombreCompleto: nombreCompleto || "-" });
            }
        } catch (error) {
            console.error("Error al consultar la empresa", error);
        }
    };
    //Función para consultar la información de una marca 
    consultarMarcaPorId = async (id) => {
        try {
            this.setState({ loading: true });
            const res = await axios.post("marcas/obtenerMarcaPorId",
                { marcaId: id },
                {
                    headers: this.props.headersToken,
                });
            const valoresFormateados = {
                ...res.data.marca,
                proveedor: { value: res.data.marca?.proveedor }
            }
            if (res.data.success === 2 && res.data.marca) {
                
                this.formRef.current.setFieldsValue(valoresFormateados);
            } else {
                message.error("No se pudo cargar la marca");
            }
        } catch (error) {
            console.error(error);
            message.error("Error al consultar marca");
        } finally {
            this.setState({ loading: false });
        }
    };


    atras() {
        if (this.props.onClose) {
            this.formRef.current.resetFields();
            this.props.onClose();
        }
    }

    onFinishFailed(e) {
        message.error("Verifica los campos obligatorios.");
    }

    async onFinish(values) {
        this.setState({ loading: true });
        try {
            let logo = null; 

            const esArchivo = (fileItem) =>{
                return (
                    fileItem && 
                    fileItem.originFileObj &&
                    (fileItem.originFileObj instanceof Blob ||
                        fileItem.originFileObj instanceof File)
                );
            }; 

            if(values.logo &&values.logo.length > 0){
                const fileItem = values.logo[0]; 
                if(esArchivo(fileItem)){
                    const base64 = await getBase64(fileItem.originFileObj); 
                    logo = {name: fileItem.name, url: base64}; 
                }else if(fileItem.urlRelativa){
                    logo = {name:"old", url:fileItem.urlRelativa}; 
                }
            }

            const payload = {
                ...values,
                logo: logo,
                marcaId : this.props.modo === "editar" ? this.props.marcaId : null,
                empresaId : this.props.empresaId, 
                usuarioId: this.props.usuarioId, 
            }

            axios
            .post(
                this.props.modo === "editar" ? "marcas/editarMarca" : "marcas/agregarMarca",
                payload,
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Marca registrada correctamente");
                    this.formRef.current.resetFields();
                    if (this.props.onClose) this.props.onClose(res.data.codigo);
                } else {
                    message.error(res.data.message || "No se pudo registrar la marca");
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al registrar la marca");
            });
        } catch (error) {
            
        }
    }

    //Función para consultar los proveedores para la marca
    async consultarProveedores() {
        try {
            const res = await axios.post(
                "proveedores/selectProveedores",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );

            if (res.data && Array.isArray(res.data)) {
                const proveedoresOptions = res.data.map((proveedor) => (
                    <Option key={proveedor._id} value={proveedor._id}>
                        {proveedor.stringBuscar}
                    </Option>
                ));

                this.setState({ proveedores: proveedoresOptions });
            } else {
                message.warning("No se encontraron proveedores activos");
            }
        } catch (err) {
            console.error("Error al consultar proveedores", err);
            message.error("Error al cargar proveedores");
        }
    }

    normFile = (e) => {
        if (Array.isArray(e)) return e;
        return e && e.fileList;
    };

    checkFileSize = (file) => {
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error("La imagen debe pesar menos de 5MB");
        }
        return false; 
    };

    render() {
        const titulo = this.props.modo === "editar" ? "Editar marca" : "Agregar marca";

        return (
            <ModalItem
                title={titulo}
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.atras.bind(this)}
                paddingTop
                width={700}
            >

                <Spin spinning={this.state.loading}>
                    <Form
                        ref={this.formRef}
                        name="agregarMarca"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Guardar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <HeaderItem>DATOS DE LA MARCA</HeaderItem>
                        <BoxItem>
                            <Row >
                                <Col span={24}>
                                    <FormItem
                                        label="Clave"
                                        name="clave"
                                        required
                                        margin
                                    >
                                        <InputItem placeholder="Clave" />
                                    </FormItem>
                                    <FormItem
                                        label="Nombre"
                                        name="nombre"
                                        required
                                        margin
                                    >
                                        <InputItem placeholder="Nombre" />
                                    </FormItem>
                                    <FormItem
                                        label="Descripción"
                                        name="descripcion"
                                        margin
                                    >
                                        <TextAreaItem placeholder="Descripción" />
                                    </FormItem>
                                    <FormItem
                                        label="Proveedor principal"
                                        name="proveedorId"
                                        margin
                                        tooltip="Seleccione al proveedor principal de la marca."
                                    >
                                        <SelectItem
                                            placeholder="Seleccionar proveedor..."
                                        >
                                            {this.state.proveedores}
                                        </SelectItem>
                                    </FormItem>
                                    <FormItem
                                        label="Sitio Web de la marca"
                                        name="sitioWeb"
                                        margin
                                        tooltip="Ingrese la URL del sitio web de la marca."
                                    >
                                        <InputItem placeholder="URL"></InputItem>
                                    </FormItem>
                                    <FormItem
                                        label="No calcular precios automaticamente"
                                        name="noCalcularPreciosAutomaticamente"
                                        margin
                                        initialValue={false}
                                        valuePropName="checked"
                                        tooltip="Al activarse, los insumos de esta marca conservan su precio aunque cambie el costo, sin importar lo que digan la lista de precios ni la configuracion de la empresa."
                                    >
                                        <SwitchItem />
                                    </FormItem>
                                    <FormItem
                                        label="Logo de la Marca"
                                        name="logo"
                                        valuePropName="fileList"
                                        getValueFromEvent={this.normFile}
                                        margin
                                    >
                                        <Upload
                                            name="logoMarcaFile"
                                            listType="picture-card"
                                            maxCount={1}
                                            beforeUpload={this.checkFileSize}
                                            accept="image/*"
                                            style={{ width: "100%" }}
                                        >
                                            <div>
                                                <PictureOutlined />
                                                <div style={{ marginTop: 8 }}>Subir</div>
                                            </div>
                                        </Upload>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24}>
                                    <Alert
                                        type="warning"
                                        showIcon
                                        style={{ marginBottom: "10px" }}
                                        message={
                                            <>
                                                El uso de la imagen y el nombre de la marca queda bajo la responsabilidad de{" "}
                                                <strong>{this.state.empresaNombreCompleto}</strong>.
                                            </>
                                        }
                                    />
                                    <FormItem
                                        name="aceptaResponsabilidad"
                                        valuePropName="checked"
                                        rules={[
                                            {
                                                validator: (_, value) =>
                                                    value
                                                        ? Promise.resolve()
                                                        : Promise.reject(new Error("Debes aceptar la responsabilidad para continuar")),
                                            },
                                        ]}
                                    >
                                        <CheckItem>
                                            Acepto la responsabilidad del uso de la imagen y el nombre de la marca.
                                        </CheckItem>
                                    </FormItem>
                                </Col>
                            </Row>
                        </BoxItem>
                    </Form>
                </Spin>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa?.id,
});

export default connect(mapStateToProps)(ModalMarca);